import { render, staticRenderFns } from "./OrderClientNameField.vue?vue&type=template&id=7cb3c79a&scoped=true"
import script from "./OrderClientNameField.vue?vue&type=script&lang=js"
export * from "./OrderClientNameField.vue?vue&type=script&lang=js"
import style0 from "./OrderClientNameField.vue?vue&type=style&index=0&id=7cb3c79a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb3c79a",
  null
  
)

export default component.exports